import { makeStyles } from '@material-ui/core';
import { mixin } from '../../utils/mixin';

// '@media(max-width: 768px)': {}
export const useStyles = makeStyles(() => ({
  check_item: {
    ...mixin.flex('center', 'flex-start'),
  }
}));
